import React from 'react';
import { withStyles } from '@material-ui/core';
import AddRoundedIcon from '@material-ui/icons/AddRounded';
import EditIcon from '@material-ui/icons/Edit';
import Tooltip from '../../../../../../common/StyledToolTip';
import SearchBox from '../../../../../../common/SearchBox';
import { Delete } from '@material-ui/icons';
import ClearAllFilterButton from '@dataGrid/components/columnFilters/ClearAllFilterButton';

const styles = (theme) => ({
  headerStyle: {
    margin: '5px 0px',
    height: '30px',
    borderRadius: '4px 4px 0 0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'end'
  },
  headerLabel: {
    color: theme.HeaderSelectedText,
    fontSize: theme.headerTextFontSize,
    fontWeight: 600
  },
  headerIconStyles: {
    padding: '5px 10px',
    borderLeft: `1px solid ${theme.AppBGColor}`,
    color: theme.iconColor
  },
  disableIcon: {
    cursor: 'not-allowed',
    opacity: 0.7
  },
  enableIcon: {
    cursor: 'pointer'
  },
  iconLayout: {
    color: theme.iconColor,
    '&>span': {
      padding: '10px 10px',
      color: theme.iconColor
    }
  },
});

const ReceiverGridHeader = ({
  classes,
  gridApi,
  selectedReceivers,
  openAddEditReceiverPanel,
  updateQuickFilterText,
  openDeleteReceiver,
  showReceiverForm
}) => {
  const getIconTitle = (params) => {
    const { iconName, disableDeleteIconEditIcon, disableAddIcon } = params;
    if (showReceiverForm) {
      return 'Add/update in progress';
    }
    switch (iconName) {
      case 'editIcon':
        if (!disableDeleteIconEditIcon) {
          return 'Click to edit';
        } else {
          return 'Select a single row to edit';
        }
      case 'deleteIcon':
        if (!disableDeleteIconEditIcon) {
          return 'Click to delete';
        } else {
          return 'Select a single row to delete';
        }
      case 'addIcon':
        return disableAddIcon ? 'Disabled' : 'Click to add';
      default:
        return '';
    }
  };

  const RenderHeaderIcon = ({ iconName, icon, isDisabled, onClick, classes, params }) => {
    const headerIconClasses = `${classes.headerIconStyles} ${classes.iconLayout} ${
      isDisabled ? classes.disableIcon : classes.enableIcon
    }`;
    const title = getIconTitle({ iconName, ...params });
    return (
      <span className={headerIconClasses} onClick={onClick}>
        <Tooltip title={title}>{icon}</Tooltip>
      </span>
    );
  };

  const disableAddIcon = showReceiverForm;
  const disableDeleteIconEditIcon = !selectedReceivers?.length || showReceiverForm;
  const params = {
    disableDeleteIconEditIcon,
    disableAddIcon
  };
  return (
    <div className={classes.headerStyle}>
      <span>
        <SearchBox onChange={updateQuickFilterText} />
      </span>
      <ClearAllFilterButton gridApi={gridApi}/>

      <RenderHeaderIcon
        isDisabled={disableDeleteIconEditIcon}
        icon={<EditIcon />}
        iconName="editIcon"
        onClick={() => !disableDeleteIconEditIcon && openAddEditReceiverPanel(selectedReceivers[0])}
        params={params}
        classes={classes}
      />

      <RenderHeaderIcon
        isDisabled={disableAddIcon}
        icon={<AddRoundedIcon />}
        iconName="addIcon"
        onClick={() => !disableAddIcon && openAddEditReceiverPanel()}
        params={params}
        classes={classes}
      />

      <RenderHeaderIcon
        isDisabled={disableDeleteIconEditIcon}
        icon={<Delete />}
        iconName="deleteIcon"
        onClick={() => !disableDeleteIconEditIcon && openDeleteReceiver(selectedReceivers[0])}
        params={params}
        classes={classes}
      />
    </div>
  );
};
export default withStyles(styles)(ReceiverGridHeader);
